import { useMemo } from "react"
import { useLocalization } from "@tm/localization"
import { renderRoute } from "@tm/utils"
import { Widget } from "@tm/controls"
import { Box, Typography, LinkButton, Stack } from "@tm/components"
import { useBackorders, useBackordersCounts } from "@tm/data/cis"
import { useParams } from "react-router"
import { BackordersTable } from "../_shared/tables/BackordersTable"
import WidgetHeaderTitleComponent from "../_shared/WidgetHeaderTitle"

type Props = {
    backordersRoute: string
}

export default function WidgetBackordersComponent({ backordersRoute }: Props) {
    const { translateText, translate } = useLocalization()
    const matchParams = useParams()
    const { backordersCount, backordersCountLoading } = useBackordersCounts()
    const { backorders, backordersLoading } = useBackorders()

    const url = renderRoute(backordersRoute, { ...matchParams })

    const backorderCountText = useMemo(() => {
        if (backordersCount) {
            return ` (${backordersCount} ${translateText(90)}) `
        }
    }, [backordersCount, translateText])

    return (
        <Widget
            size="4x2"
            iconName="voucher"
            title={translate(13173)}
            header={
                <WidgetHeaderTitleComponent
                    iconName="voucher"
                    titleTextId={13173}
                    additionalInfoLoading={backordersCountLoading}
                    additionalInfo={backorderCountText}
                />
            }
            active
        >
            <Stack spacing={0.5}>
                <Box alignContent="center">
                    <Box height="187px" maxHeight="100%">
                        {/* height: legacy code, thats a no go */}
                        <BackordersTable variant="small" backorders={backorders} backordersLoading={backordersLoading} />
                    </Box>
                </Box>
                <Box display="flex" justifyContent="space-between">
                    <Typography variant="label">{`*${translate(694)}`}</Typography>
                    <LinkButton to={url} disabled={backordersLoading}>
                        {translate(43)}
                    </LinkButton>
                </Box>
            </Stack>
        </Widget>
    )
}
